<template><span class="ui-loading-spinner" role="status" aria-label="Loading"></span></template>

<script>
export default { name: "LoadingSmallDiv" };
</script>

<style scoped>
.ui-loading-spinner {
  animation: ui-loading-spin 750ms linear infinite;
  border: 2px solid var(--ui-border);
  border-radius: 50%;
  border-top-color: var(--ui-primary);
  display: inline-block;
  height: 1.25rem;
  width: 1.25rem;
}
@keyframes ui-loading-spin { to { transform: rotate(360deg); } }
</style>
